/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../api/api';
import {LocalInactiveTargets} from '../session/local-inactive-targets';
import {AdnHttpService} from './adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from './create-adn-http-resource';
import {AuthHttpInterceptorService} from '../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../app/common/directives/error/api-error-handler.service';



export interface InactiveTargetsData {
  creatives?: any[];
  lineItems?: any[];
}

@Injectable()
export class AdnInactiveTargetsService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  cancelExistingData(id: string): void {
    const inactiveTargets = LocalInactiveTargets.obtain().getInactiveTargets();
    if (inactiveTargets) {
      let hasId = _.find(inactiveTargets.lineItems, (li: any) => {
        return _.get(li, ['lineItem', 'id']) === id;
      });
      if (!hasId) {
        hasId = _.find(inactiveTargets.creatives, (li: any) => {
          return _.get(li, ['creative', 'id']) === id;
        });
      }
      if (hasId) {
        LocalInactiveTargets.obtain().setInactiveTargets();
      }
    }
  }

  results(forceCall?: boolean): Promise<InactiveTargetsData> {
    const inactiveTargets = LocalInactiveTargets.obtain().getInactiveTargets(forceCall);
    if (inactiveTargets) {
      return Promise.resolve(inactiveTargets);
    }
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['inactivetargets']),
      params: _.assign({}, {format: 'json'})
    }).then((response: any) => {
      const data: InactiveTargetsData = response || {creatives: [], lineItems: []};
      LocalInactiveTargets.obtain().setInactiveTargets(data);
      return data;
    }).catch(() => {
      return {creatives: [], lineItems: []};
    });
  }
}
